import { UserAuthProfile, UserPerson, UserToOrganization } from '../types';
import { CommonTeamsResponse, TeamMembersResponse } from '../types/thematicGroups';
import { apiNetworking, apiOrchestrator } from 'services/apiService';

export const getOrganizationUsers = async (): Promise<UserToOrganization[]> => {
  const { data } = await apiOrchestrator.get<UserToOrganization[]>(
    '/user_to_organization/members/short'
  );
  return data;
};

export const getUserPerson = async (userPersonUuid: string): Promise<UserPerson> => {
  const { data } = await apiOrchestrator.get<UserPerson>(`/users-person/${userPersonUuid}`);
  return data;
};

export const getUserAuthProfile = async (userId: string): Promise<UserAuthProfile> => {
  const { data } = await apiOrchestrator.get<UserAuthProfile>(`/auth/me/${userId}`);
  return data;
};

export const getMemberConnectionLevels = async (
  userId: string
): Promise<Record<string, number>> => {
  const { data } = await apiNetworking.get<Record<string, number>>(
    `/graph/${userId}/shortest-path-lengths`
  );
  return data;
};

export const getCommonTeams = async (
  userUuid1: string,
  userUuid2: string
): Promise<CommonTeamsResponse> => {
  const { data } = await apiOrchestrator.get<CommonTeamsResponse>(
    `/team/common-teams/${userUuid1}/${userUuid2}`
  );
  return data;
};

export const getTeamMembers = async (
  teamUuid: string,
  page: number = 1,
  size: number = 50
): Promise<TeamMembersResponse> => {
  const { data } = await apiOrchestrator.get<TeamMembersResponse>(`/team/${teamUuid}/members`, {
    params: { page, size },
  });
  return data;
};
